import { axios } from "../../lib/axios";

export const getDollarRate = (): Promise<{ dollarRate: number }> =>
  axios.get("/settings/dollar-rate").then((res) => res.data.data);

export const updateDollarRate = (value: number): Promise<{ dollarRate: number }> =>
  axios.patch("/settings/dollar-rate", { value }).then((res) => res.data.data);
